import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const SESSION_KEY = 'lh_session_id';
const getSessionId = () => {
  try {
    let s = sessionStorage.getItem(SESSION_KEY);
    if (!s) {
      s =
        (typeof crypto !== 'undefined' && crypto.randomUUID
          ? crypto.randomUUID()
          : `${Date.now()}-${Math.random().toString(36).slice(2)}`);
      sessionStorage.setItem(SESSION_KEY, s);
    }
    return s;
  } catch {
    return `anon-${Math.random().toString(36).slice(2)}`;
  }
};

/**
 * AnalyticsBeacon — fires a `pageview` event to /api/analytics/event on every
 * route change. Powers the Live audience snapshot on the Advertise pages.
 *
 * Strictly first-party; no third-party scripts. Privacy-friendly.
 */
const AnalyticsBeacon = () => {
  const { pathname, search } = useLocation();
  useEffect(() => {
    const path = pathname + (search || '');
    const session_id = getSessionId();
    const referrer = document.referrer || '';
    const type = path.includes('/listings') || path.includes('/buy') || path.includes('/rent')
      ? 'search'
      : 'pageview';
    axios
      .post(`${BACKEND_URL}/api/analytics/event`, { type, path, session_id, referrer })
      .catch(() => {});
  }, [pathname, search]);
  return null;
};

export default AnalyticsBeacon;
